import React, {Component} from 'react';

export const Context = (context) => (WrappedComponent) => {
    return class extends Component {
        
       ctxs = ()=>{
           let dados = {}
           Object.keys(context).map((ctx)=>{
                let dctx = context[ctx]._currentValue;
                dados[ctx.toLowerCase()] = dctx;
                return dctx;
           });
           return dados;
       }
       render() {
          let ctxs = this.ctxs();
          return <WrappedComponent ctx={ctxs} />
       }
    }
 }